import { emojiIdToNative, legacyEmojiRegex } from './emoji.types';

export function convertTextToNativeEmojis(text: string): string {
  const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/g;

  // Split the text into parts based on URL matches
  const parts = text.split(urlRegex);
  const urls = text.match(urlRegex);

  const legacyRegex = new RegExp(legacyEmojiRegex, 'g');

  // Replace emojis in each part that is not a URL
  for (let i = 0; i < parts.length; i++) {
    parts[i] = parts[i].replace(legacyRegex, match => emojiIdToNative[match]);
  }

  // Reconstruct the text by interleaving parts and URLs
  let result = '';
  for (let i = 0; i < parts.length; i++) {
    result += parts[i];
    if (urls && urls[i]) {
      result += urls[i];
    }
  }

  return result;
}
